import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Directive({
  selector: '[appCustomStyles]'
})
export class CustomStylesDirective {
  public themeItems: any;
  public baseUrl: string;
  public mainBackground: string;
  public primaryColor: string;

  constructor(public el: ElementRef, public renderer: Renderer2, private themeService: ThemeService) {
    // this.themeItems = this.themeService.getTheme().once('value', themeSnapshot => {
    //   this.baseUrl = themeSnapshot.val().baseUrl;
    //   this.mainBackground = themeSnapshot.val().baseurl + themeSnapshot.val().main_background;
    //   this.primaryColor = themeSnapshot.val().primary_color;
    //   this.renderer.setStyle(el.nativeElement, 'background', 'url(' + this.mainBackground + ') no-repeat');
    //   this.renderer.setStyle(el.nativeElement, 'background-size', 'cover');
    //   this.renderer.setStyle(el.nativeElement, 'border', this.primaryColor + ' solid 2px');
    //   this.renderer.setStyle(el.nativeElement, 'color', 'red');
    //   this.renderer.setStyle(el.nativeElement, 'height', '100%');
    // });
   }

}
